import { themeVars } from '../theme/vars';
import { style } from '../layer.css';

export const separator = style({
  height: '1px',
  border: 0,
  backgroundColor: themeVars.container.border.default,
});
